import { render } from "./ServiceArea.vue?vue&type=template&id=36f6fb97&scoped=true"
import script from "./ServiceArea.vue?vue&type=script&lang=js"
export * from "./ServiceArea.vue?vue&type=script&lang=js"

import "./ServiceArea.vue?vue&type=style&index=0&id=36f6fb97&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6fb97"]])

export default __exports__